import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const WarningLoadTimeIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon
      viewBox="0 0 24 24"
      className={styles.icon}
      width="24"
      height="24"
      fill="none"
    >
      <mask
        id="warningLoadTimeIcon0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#warningLoadTimeIcon0)">
        <circle cx="12" cy="12" r="12" fill="#DC0032" />
      </g>
      <mask
        id="warningLoadTimeIcon1"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="5"
        y="4"
        width="14"
        height="15"
      >
        <path d="M5 4.5H19V18.5H5V4.5Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#warningLoadTimeIcon1)">
        <path
          d="M18.8159 15.6488L13.2832 5.92716C13.0303 5.46874 12.556 5.20001 12.0028 5.20001C11.4495 5.20001 10.9911 5.46874 10.7224 5.92716L5.18969 15.6488C4.93677 16.1073 4.93677 16.6605 5.18969 17.119C5.44261 17.5774 5.91684 17.8461 6.4543 17.8461H17.5038C18.0413 17.8461 18.5155 17.5774 18.7684 17.119C19.0688 16.6605 19.0688 16.1073 18.8159 15.6488ZM12.809 15.5382H11.3389V14.2578H12.809V15.5382ZM12.809 13.5148H11.3389V9.84745H12.809V13.5148Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(WarningLoadTimeIcon);
